import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';

import { useCallback, useEffect, useState } from 'react';
import { ISiteMngData } from '../types';
import { MRT_TableInstance } from 'material-react-table';
import AlertModal from '../Modals/AlertModal';

interface IProps {
  data: ISiteMngData[];
  setData: (newData: ISiteMngData[]) => void;
  table: MRT_TableInstance<ISiteMngData>;
  setEditedUids: (any: any) => void;
}

interface IOptInAlertModal {
  open: boolean;
  message: string;
  title?: string;
  primaryButton?: { label: string; onClick: () => void };
  cancelLabel?: string;
}

const OptInOption: React.FC<IProps> = (props) => {
  const [checked, setChecked] = useState(false);
  const [showOptInLabel, setShowOptInLabel] = useState(true);
  const [alertModal, setAlertModal] = useState<IOptInAlertModal>({
    open: false,
    message: '',
  });

  const closeAlertModal = useCallback(() => {
    setAlertModal({
      open: false,
      message: '',
      title: undefined,
      primaryButton: undefined,
      cancelLabel: undefined,
    });
  }, []);

  useEffect(() => {
    const selectedRows = props.table.getSelectedRowModel().rows;

    if (Array.isArray(selectedRows) && selectedRows.length > 0) {
      const allOptedIn = selectedRows?.every((item) => item?.original?.optedIn);
      setShowOptInLabel(allOptedIn ? false : true);
    } else {
      const allOptedIn = props?.data?.every((item) => item?.optedIn);
      setShowOptInLabel(allOptedIn ? false : true);
    }
  }, [props]);

  const runBulkOptApply = useCallback(
    (value: boolean, optInTarget: boolean) => {
      const selectedRows = props.table.getSelectedRowModel().rows;
      if (!Array.isArray(selectedRows) || selectedRows.length < 1) {
        return;
      }
      const ids = selectedRows.map((item) => item.id);
      const idMap: Record<string, boolean> = {};
      ids.forEach((id) => {
        idMap[id] = true;
      });
      const newData = props.data.map((item) => {
        if (idMap[item.uid]) {
          props.setEditedUids((arr: any) => [...arr, item.uid]);
          return { ...item, optedIn: optInTarget };
        }
        return item;
      });
      props.setData(newData);
      setChecked(value);
    },
    [props]
  );

  return (
    <Box>
      <AlertModal
        open={alertModal.open}
        message={alertModal.message}
        title={alertModal.title}
        primaryButton={alertModal.primaryButton}
        cancelLabel={alertModal.cancelLabel}
        onClose={closeAlertModal}
      />
      <FormControlLabel
        label={showOptInLabel ? 'Opt All In' : 'Opt All Out'}
        control={
          <Checkbox
            checked={checked}
            onChange={(event) => {
              const value = event.target.checked;
              const selectedRows = props.table.getSelectedRowModel().rows;
              const optInTarget = showOptInLabel;

              if (!Array.isArray(selectedRows) || selectedRows.length < 1) {
                setAlertModal({
                  open: true,
                  title: 'No rows selected',
                  message: 'Select at least one row to perform bulk opt in or opt out.',
                });
                return;
              }

              setAlertModal({
                open: true,
                title: showOptInLabel ? 'Confirm opt all in' : 'Confirm opt all out',
                message: `This will modify ${selectedRows.length} row(s). Continue?`,
                primaryButton: {
                  label: 'Proceed',
                  onClick: () => {
                    closeAlertModal();
                    runBulkOptApply(value, optInTarget);
                  },
                },
                cancelLabel: 'Cancel',
              });
            }}
          />
        }
      />
    </Box>
  );
};

export default OptInOption;
